import { Component, OnInit, ViewChild } from '@angular/core';
import { Promocao } from '../models/promocao';
import { MatPaginator, PageEvent, MatDialog } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { PromocaoService } from '../services/promocao.service';
import { CarregandoService } from '../services/carregando.service';
import { NotificacaoService } from '../services/notificacao.service';
import { UtilitarioService } from '../services/utilitario.service';
import swal from 'sweetalert2';
import { SegmentacaoService } from '../services/segmentacao.service';
import { Segmentacao } from '../models/segmentacao';
import { PaginatorService } from '../services/paginator.service';

@Component({
  selector: 'app-promocao',
  templateUrl: './promocao.component.html',
  styleUrls: ['./promocao.component.scss']
})
export class PromocaoComponent implements OnInit {
  promocoesFiltradas: Promocao[] = [];
  filtroTitulo: string;
  carregando = true;
  campoOrdenacao = 'descricao';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  classificacoes: Segmentacao[] = [];
  campanha = false;

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(
    private router: Router,
    private promocaoService: PromocaoService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private segmentacaoService: SegmentacaoService,
    private route: ActivatedRoute,
    private paginatorService: PaginatorService
  ) {
    this.route.data.subscribe(data => {
      this.campanha = data['campanha'];
    });
  }

  ngOnInit(): void {
    const pagination = this.paginatorService.consultarPaginacao();
    
    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarClassificacao()
      .then(() => this.buscarPromocoes());
  }

  novaPromocao() {
    this.router.navigate([this.campanha ? 'configuracoes/campanhas/novo' : 'configuracoes/promocao/novo']);
  }

  buscarDescricaoClassificacao(idClassificacao: number) {
    return this.classificacoes.find(p => p.id === idClassificacao).descricao;
  }

  editarPromocao(promocao: Promocao) {
    this.router.navigate([this.campanha ? 'configuracoes/campanhas/editar' : 'configuracoes/promocao/editar', promocao.id]);
  }

  excluirPromocao(promocao: Promocao) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir a ' + (this.campanha ? 'Campanha?' : 'Promoção?'),
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluirPromocao');
        this.promocaoService.excluir(promocao.id).subscribe(resp => {
          this.notificacaoService.sucesso('Promoção excluída com sucesso!!!');
          this.carregandoService.esconde('excluirPromocao');
          this.buscarPromocoes();
        }, (erro) => {
          this.carregandoService.esconde('excluirPromocao');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  buscarClassificacao() {
    return new Promise<void>((resolve) => {
      this.carregandoService.mostra('buscarClassificacao');

      this.segmentacaoService.consultar().subscribe(dados => {
        this.classificacoes = dados;
        this.carregandoService.esconde('buscarClassificacao');
        resolve();
      }, (erro) => {
        this.carregandoService.esconde('buscarClassificacao');
        this.notificacaoService.erro(erro);
      });
    });
  }

  buscarPromocoes() {
    this.carregandoService.mostra('buscaPromocoes');

    if(!this.campanha) this.campanha = false;

    this.promocaoService.consultarComPaginacao(this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc', this.filtroTitulo, this.campanha).subscribe(dados => {
      this.promocoesFiltradas = dados.itens;

      if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
        this.itensPorPagina = 10;
      }

      this.paginacao.total = dados.total;
      this.carregandoService.esconde('buscaPromocoes');
    }, (erro) => {
      this.carregandoService.esconde('buscaPromocoes');
      this.notificacaoService.erro(erro);
    });
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarPromocoes();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }
  filtrar() {
    this.buscarPromocoes();
    this.paginator.firstPage();
  }
}